/* global window document */

import $ from 'jquery';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import { i18n } from '../../translation';
import { trackSearch } from '../../scripts/tag-manager';
import { RestComponent } from '../mixins/rest-component';
import './Search.scss';
import template from './Search.vhtml';

const currentLanguage = window.siteData.language || 'da';
let request = null;

export default {
	name: 'Search',
	mixins: [RestComponent],
	template: template,
	props: {
		placeholder: {
			type: String,
			default: i18n.t('search'),
		},
	},
	data: () => ({
		s: '',
		results: [],
		error: '',
		isLoading: false,
		total: 0,
		isChanging: false,
		isInputFocused: false,
	}),
	computed: {
		placeholderFormated: (vm) => `${vm.placeholder}...`,
	},
	watch: {
		s() {
			if (!this.isChanging) this.isChanging = true;
			this.updateUrl('search_str', this.s);
			if (this.s !== '') {
				this.search(this.s);
			} else {
				this.resetResults();
			}
		},
	},
	methods: {
		setupBgi: (img) => `url(${img})`,
		clearSearch() {
			this.s = '';
			this.resetResults();
			this.blurInput();
		},
		resetResults() {
			this.results = [];
		},
		hasChanged: debounce(() => {
			this.isChanging = false;
		}, 1000),
		focusInput() {
			window.scrollTo(0, 0);
			document.body.scrollTop = 0;
			this.isInputFocused = true;
		},
		blurInput() {
			if (this.s === '' && this.results.length === 0) {
				this.isInputFocused = false;
			}
		},
		search: debounce(function (query) {
			if (query.length > 0) {
				this.isLoading = true;
				const endpoint = `/wp-json/be/v1/search`;
				const params = {
					s: query,
					lang: this.language,
				};
				if (request) {
					request.abort();
				}
				request = $.ajax({
					type: 'GET',
					url: endpoint,
					data: params,
				});

				request
					.catch(() => {
						this.total = 0;
						this.results = [];
					})
					.then((result) => {
						if (result) {
							if (typeof result != 'object') {
								result = JSON.parse(result);
							}
							this.total = get(result, 'total', 0);
							this.results = get(result, 'data', []);

							trackSearch(query, 'MainSearch');
						}
					})
					.always(() => {
						this.isLoading = false;
						this.isChanging = false;
					});
			} else {
				this.error = '';
				this.resetResults();
			}
		}, 500),
	},
	beforeMount() {
		this.s = decodeURI(get(this.getUrlVars(), 'search_str', ''));
		if (this.s !== '') this.focusInput();
	},
};
